
<footer class="w-full text-white pt-10 pb-6 bg-gradient-to-br from-primary-500 to-primary-600">
  <div class="container mx-auto px-6">
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-10">
  
      <div class="flex gap-4">
        <div class="aspect-square w-24 h-24 bg-white rounded-lg flex items-center justify-center p-3">
          <img src="assets/images/tsn.png" class="h-full w-auto object-contain" alt="TSN Logo">
        </div>
        <div class="flex flex-col">
          <p class="font-bold text-lg">The United Republic of Tanzania</p>
          <hr class="my-1 w-1/3 h-0.5 border-0 bg-white">
          <p class="font-bold text-lg">Tanzania Standard Newspapers Ltd</p>
          <p class="text-white/90 text-sm leading-snug">
            Publisher of Daily News, HabariLeo, Sunday News and other publications.
          </p>
        </div>
      </div>

 
      <div class="flex flex-col items-start mx-auto">
        <p class="font-bold text-lg mb-2">Follow Us</p>
          <!-- <hr class="my-1 w-1/3 h-0.5 border-0 bg-white"> -->
        <div class="flex flex-col gap-4 w-full max-w-xs">
          <a href="https://www.facebook.com/DailynewsTanzania/" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:opacity-70 transition">
            <svg class="size-6 fill-white flex-shrink-0" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.791-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.512c-1.492 0-1.956.925-1.956 1.874v2.249h3.328l-.532 3.47h-2.796v8.385c5.737-.9 10.125-5.864 10.125-11.854z"/>
            </svg>
            <span class="text-left flex-1">Daily News on Facebook</span>
          </a>
          <a href="https://twitter.com.com/dailynewstz" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:opacity-70 transition">
            <svg class="size-6 fill-white flex-shrink-0" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.762l4.713 6.231zm-1.161 17.52h1.464L7.084 4.126h-1.564z"/>
            </svg>
            <span class="text-left flex-1">Daily News on Twitter</span>
          </a>
          <a href="https://www.instagram.com/dailynews_tz/" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:opacity-70 transition">
            <svg class="size-6 fill-white flex-shrink-0" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.584.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.667-.014 4.947-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.281.073-1.689.073-4.948 0-3.259-.014-3.668-.072-4.948-.2-4.358-2.618-6.78-6.98-6.98-1.281-.058-1.689-.073-4.948-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.162 6.162 6.162 6.162-2.759 6.162-6.162-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.441s.645 1.441 1.441 1.441 1.441-.645 1.441-1.441-.645-1.441-1.441-1.441z"/>
            </svg>
            <span class="text-left flex-1">Daily News on Instagram</span>
          </a>
          <a href="https://www.youtube.com/c/DailyNewsDigital" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:opacity-70 transition">
            <svg class="size-6 fill-white flex-shrink-0" viewBox="0 0 24 24">
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.356 8.816 0 6.196 1.412 8.55 4.356 8.816 3.6.246 11.631.245 15.23 0 3.897-.266 4.356-2.62 4.356-8.816 0-6.196-1.412-8.55-4.356-8.816zm-10.615 12.816v-8l8 4-8 4z"/>
            </svg>
            <span class="text-left flex-1">Daily News on YouTube</span>
          </a>
        </div>
      </div>

    
      <div class="flex flex-col">
        <p class="font-bold text-lg mb-2">Quick Links</p>
        <!-- <hr class="my-1 w-1/3 h-0.5 border-0 bg-white"> -->
        <div class="flex flex-col gap-1">
          <a href="https://www.dailynews.co.tz/" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:underline">
            <mat-icon class="text-white">chevron_right</mat-icon>
            <span class="flex-1 text-left">Daily News</span>
          </a>
          <a href="https://www.habarileo.co.tz/" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:underline">
            <mat-icon class="text-white">chevron_right</mat-icon>
            <span class="flex-1 text-left">HabariLeo</span>
          </a>
          <a href="https://www.spotileo.co.tz/" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:underline">
            <mat-icon class="text-white">chevron_right</mat-icon>
            <span class="flex-1 text-left">SpotiLeo</span>
          </a>
          <a href="https://epaper.tsn.go.tz/" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:underline">
            <mat-icon class="text-white">chevron_right</mat-icon>
            <span class="flex-1 text-left">TSN Official Website</span>
          </a>
          <a href="https://play.google.com/store/apps/details?id=news.tsn.go.tz" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:underline">
            <mat-icon class="text-white">chevron_right</mat-icon>
            <span class="flex-1 text-left">Download on Google Play</span>
          </a>
          <a href="https://apps.apple.com/us/app/tanzania-standard-newspapers/id1343872270" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-4 hover:underline">
            <mat-icon class="text-white">chevron_right</mat-icon>
            <span class="flex-1 text-left">Download on App Store</span>
          </a>
        </div>
      </div>
    </div>

  
    <div class="mt-10 border-t-2 border-white/70 pt-6 text-center">
    </div>

 
    <div class="flex flex-col sm:flex-row justify-between mt-8 text-center text-sm gap-4">
      <span>&copy; {{ currentYear }} Tanzania Standard Newspapers Ltd. All rights reserved.</span>
      <div class="flex flex-wrap justify-center gap-4">
        <span class="underline cursor-pointer">Privacy Policy</span> |
        <span class="underline cursor-pointer">Terms and Conditions</span>
      </div>
    </div>
  </div>
</footer>